import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetFolders,
    requestCreateFolder,
    requestGetFolderInfoById,
    requestUpdateFolderById,
    requestDeleteFolderById,
    requestGetFilesByFolderId,
    requestCreateFilesByFolderId,
    requestGetFileInfoById,
    requestDownloadFilesByFileId,
    requestUpdateFileByFileId,
    requestDeleteFileByFileId,

    requestUmeGetFolders,
    requestUmeCreateFolder,
    requestUmeGetFolderInfoById,
    requestUmeUpdateFolderById,
    requestUmeDeleteFolderById,
    requestUmeGetFilesByFolderId,
    requestUmeCreateFilesByFolderId,
    requestUmeGetFileInfoById,
    requestUmeDownloadFilesByFileId,
    requestUmeUpdateFileByFileId,
    requestUmeDeleteFileByFileId,

    requestUmeGetFolderPermissions,
    // requestUmeGetFolderPermissionsById,
    requestUmeCreateFolderPermissions,
    requestUmeDeleteFolderPermissions,
    requestUmeDeleteFolderPermissionsById
} from "api/menu/file-manager/requests";

export const FM_LOADING = "FM_LOADING";
export const FM_SELECT_FOLDER = "FM_SELECT_FOLDER";
export const FM_SELECT_FILE = "FM_SELECT_FILE";
export const FM_SEARCH_BY_JOB = "FM_SEARCH_BY_JOB";

export const FM_GET_FOLDERS = "FM_GET_FOLDERS";
export const FM_CREATE_FOLDER = "FM_CREATE_FOLDER";
export const FM_GET_FOLDER_INFO_BY_ID = "FM_GET_FOLDER_INFO_BY_ID";
export const FM_UPDATE_FOLDER_BY_ID = "FM_UPDATE_FOLDER_BY_ID";
export const FM_DELETE_FOLDER_BY_ID = "FM_DELETE_FOLDER_BY_ID";
export const FM_GET_FILES_BY_FOLDER_ID = "FM_GET_FILES_BY_FOLDER_ID";
export const FM_CREATE_FILES_BY_FOLDER_ID = "FM_CREATE_FILES_BY_FOLDER_ID";
export const FM_GET_FILE_INFO_BY_ID = "FM_GET_FILE_INFO_BY_ID";
export const FM_UPDATE_FILE_BY_FILE_ID = "FM_UPDATE_FILE_BY_FILE_ID";
export const FM_DELETE_FILE_BY_FILE_ID = "FM_DELETE_FILE_BY_FILE_ID";

export const UME_GET_FOLDERS = "UME_GET_FOLDERS";
export const UME_CREATE_FOLDER = "UME_CREATE_FOLDER";
export const UME_GET_FOLDER_INFO_BY_ID = "UME_GET_FOLDER_INFO_BY_ID";
export const UME_UPDATE_FOLDER_BY_ID = "UME_UPDATE_FOLDER_BY_ID";
export const UME_DELETE_FOLDER_BY_ID = "UME_DELETE_FOLDER_BY_ID";
export const UME_GET_FILES_BY_FOLDER_ID = "UME_GET_FILES_BY_FOLDER_ID";
export const UME_CREATE_FILES_BY_FOLDER_ID = "UME_CREATE_FILES_BY_FOLDER_ID";
export const UME_GET_FILE_INFO_BY_ID = "UME_GET_FILE_INFO_BY_ID";
export const UME_UPDATE_FILE_BY_FILE_ID = "UME_UPDATE_FILE_BY_FILE_ID";
export const UME_DELETE_FILE_BY_FILE_ID = "UME_DELETE_FILE_BY_FILE_ID";
export const UME_GET_FOLDER_PERMISSIONS = "UME_GET_FOLDER_PERMISSIONS";
export const UME_CREATE_FOLDER_PERMISSIONS = "UME_CREATE_FOLDER_PERMISSIONS";
export const UME_DELETE_FOLDER_PERMISSIONS = "UME_DELETE_FOLDER_PERMISSIONS";
export const UME_DELETE_FOLDER_PERMISSIONS_BY_ID = "UME_DELETE_FOLDER_PERMISSIONS_BY_ID";

export const setLoading = (status) => ({
    type: FM_LOADING,
    payload: status
});

export const searchByJob = (str) => dispatch => {
    dispatch({
        type: FM_SEARCH_BY_JOB,
        payload: str
    });
};

export const selectFolder = (folderId) => dispatch => {
    dispatch({
        type: FM_SELECT_FOLDER,
        payload: folderId
    });
};

export const selectFile = (fileId) => dispatch => {
    dispatch({
        type: FM_SELECT_FILE,
        payload: fileId
    });
};

export const getFolders = () => dispatch => {
    dispatch(setLoading(true));
    requestGetFolders()
        .then(response => {
            dispatch({
                type: FM_GET_FOLDERS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const createFolder = (folderName, parentId) => dispatch => {
    dispatch(setLoading(true));
    requestCreateFolder(folderName, parentId)
        .then(response => {
            dispatch({
                type: FM_CREATE_FOLDER,
                payload: response.data
            });
            toast("Folder created successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const getFolderInfoById = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestGetFolderInfoById(folderId)
        .then(response => {
            dispatch({
                type: FM_GET_FOLDER_INFO_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const updateFolderById = (folderId, data) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateFolderById(folderId, data)
        .then(response => {
            dispatch({
                type: FM_UPDATE_FOLDER_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const deleteFolderById = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteFolderById(folderId)
        .then(() => {
            dispatch({
                type: FM_DELETE_FOLDER_BY_ID,
                payload: folderId
            });

            toast("Folder deleted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const getFilesByFolderId = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestGetFilesByFolderId(folderId)
        .then(response => {
            dispatch({
                type: FM_GET_FILES_BY_FOLDER_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const createFilesByFolderId = (folderId, files) => dispatch => {
    dispatch(setLoading(true));
    requestCreateFilesByFolderId(folderId, files)
        .then(response => {
            dispatch({
                type: FM_CREATE_FILES_BY_FOLDER_ID,
                payload: response.data
            });
            toast("File uploaded successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const getFileInfoById = (fileId) => dispatch => {
    dispatch(setLoading(true));
    requestGetFileInfoById(fileId)
        .then(response => {
            dispatch({
                type: FM_GET_FILE_INFO_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const getDownloadFilesByFileId = (fileId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestDownloadFilesByFileId(fileId)
        .then(response => {
            dispatch(setLoading(false));
            callback(response.data);
        })
        .catch(() => {
            toast("File Not Found", {
                type: toast.TYPE.ERROR,
            });
            dispatch(setLoading(false));
        });
};

export const updateFileByFileId = (fileId, data) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateFileByFileId(fileId, data)
        .then(response => {
            dispatch({
                type: FM_UPDATE_FILE_BY_FILE_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const deleteFileByFileId = (fileId) => dispatch => {
    dispatch(setLoading(true));
    requestDeleteFileByFileId(fileId)
        .then(response => {
            dispatch({
                type: FM_DELETE_FILE_BY_FILE_ID,
                payload: response.data
            });
            toast("File deleted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(() => {
            toast("File Not Found", {
                type: toast.TYPE.ERROR,
            });
            dispatch(setLoading(false));
        });
};

/* UME */

export const umeGetFolders = () => dispatch => {
    dispatch(setLoading(true));
    requestUmeGetFolders()
        .then(response => {
            dispatch({
                type: UME_GET_FOLDERS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeCreateFolder = (folderName, parentId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeCreateFolder(folderName, parentId)
        .then(response => {
            dispatch({
                type: UME_CREATE_FOLDER,
                payload: response.data
            });
            toast("Folder created successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeGetFolderInfoById = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeGetFolderInfoById(folderId)
        .then(response => {
            dispatch({
                type: UME_GET_FOLDER_INFO_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeUpdateFolderById = (folderId, data) => dispatch => {
    dispatch(setLoading(true));
    requestUmeUpdateFolderById(folderId, data)
        .then(response => {
            dispatch({
                type: UME_UPDATE_FOLDER_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeDeleteFolderById = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeDeleteFolderById(folderId)
        .then(() => {
            dispatch({
                type: UME_DELETE_FOLDER_BY_ID,
                payload: folderId
            });

            toast("Folder deleted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeGetFilesByFolderId = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeGetFilesByFolderId(folderId)
        .then(response => {
            dispatch({
                type: UME_GET_FILES_BY_FOLDER_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeCreateFilesByFolderId = (folderId, files) => dispatch => {
    dispatch(setLoading(true));
    requestUmeCreateFilesByFolderId(folderId, files)
        .then(response => {
            dispatch({
                type: UME_CREATE_FILES_BY_FOLDER_ID,
                payload: response.data
            });
            toast("File uploaded successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeGetFileInfoById = (fileId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeGetFileInfoById(fileId)
        .then(response => {
            dispatch({
                type: UME_GET_FILE_INFO_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeGetDownloadFilesByFileId = (fileId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUmeDownloadFilesByFileId(fileId)
        .then(response => {
            dispatch(setLoading(false));
            callback(response.data);
        })
        .catch(() => {
            toast("File Not Found", {
                type: toast.TYPE.ERROR,
            });
            dispatch(setLoading(false));
        });
};

export const umeUpdateFileByFileId = (fileId, data) => dispatch => {
    dispatch(setLoading(true));
    requestUmeUpdateFileByFileId(fileId, data)
        .then(response => {
            dispatch({
                type: UME_UPDATE_FILE_BY_FILE_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, "", true));
        });
};

export const umeDeleteFileByFileId = (fileId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeDeleteFileByFileId(fileId)
        .then(response => {
            dispatch({
                type: UME_DELETE_FILE_BY_FILE_ID,
                payload: response.data
            });
            toast("File deleted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(() => {
            toast("File Not Found", {
                type: toast.TYPE.ERROR,
            });
            dispatch(setLoading(false));
        });
};

export const umeGetFolderPermissions = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeGetFolderPermissions(folderId)
        .then(response => {
            dispatch({
                type: UME_GET_FOLDER_PERMISSIONS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setLoading(false));
        });
};

export const umeCreateFolderPermissions = (folderId, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUmeCreateFolderPermissions(folderId, data)
        .then(response => {
            dispatch({
                type: UME_CREATE_FOLDER_PERMISSIONS,
                payload: response.data
            });
            callback(true);
        })
        .catch(() => {
            dispatch(setLoading(false));
            callback(false);
        });
};

export const umeDeleteFolderPermissions = (folderId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeDeleteFolderPermissions(folderId)
        .then(response => {
            dispatch({
                type: UME_DELETE_FOLDER_PERMISSIONS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setLoading(false));
        });
};

export const umeDeleteFolderPermissionsById = (permissionId) => dispatch => {
    dispatch(setLoading(true));
    requestUmeDeleteFolderPermissionsById(permissionId)
        .then(() => {
            dispatch({
                type: UME_DELETE_FOLDER_PERMISSIONS_BY_ID,
                payload: permissionId
            });
        })
        .catch(() => {
            dispatch(setLoading(false));
        });
};
